import { PiwikEvent } from '../../@types/common';

declare const window: any;

export const trackEvent = (event: PiwikEvent) => {
  window?._paq?.push(['trackEvent', event.category, event.action, event.name, event.value]);
};
